<template>

</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

import { oauth } from '../../services/oauth_service'

@Component
export default class Savio extends Vue {
  async created() {
    let to = this.$route.query['encuesta'] as string
    if (window.history.replaceState) {
      window.history.replaceState({}, document.title, `#${this.$route.path}`)
    } else {
      window.location.assign(`#/${this.$route.path}`)
    }
    await oauth.fakeLogin()
    
    this.$router.replace({ path: to ? `/dinamica/${to}` : '/caracterizacion' })
  }
}
</script>